export function monthDiff(d1: Date, d2: Date | undefined): number {
  if (!d1 || !d2) {
    return -1
  }
  const d1Y = d1.getFullYear()
  const d2Y = d2.getFullYear()
  const d1M = d1.getMonth()
  const d2M = d2.getMonth()

  return d2M + 12 * d2Y - (d1M + 12 * d1Y)
}

export function membershipExpirationStatus(expirationDate: string | Date) {
  const expiration = new Date(expirationDate)

  const expiredMembership = expiration < new Date()

  const difference = monthDiff(new Date(), expiration)
  const activeMembershipEligibleForRenewal = difference <= 6 && difference > -1
  const activeMemberhipNotEligibleForRenewal = difference > 6

  return {
    expiredMembership,
    activeMembershipEligibleForRenewal,
    activeMemberhipNotEligibleForRenewal,
  }
}

export function ageConfirmed(dateOfBirth: Date, requiredAge: number) {
  const subtractYears = (numOfYears, date = new Date()) => {
    date.setFullYear(date.getFullYear() - numOfYears)
    return date
  }
  const yearsAgo = subtractYears(requiredAge, new Date())
  const isOldEnoughToEnroll = dateOfBirth.getTime() < yearsAgo.getTime()
  return isOldEnoughToEnroll
}

export const isAgeQualifiedForYoungAdult = (dob: Date | undefined) => {
  if (!dob) {
    return false
  }
  const today = new Date()

  // Extract local date components (avoids timezone issues)
  const birthYear = dob.getUTCFullYear()
  const birthMonth = dob.getUTCMonth() + 1
  const birthDay = dob.getUTCDate()
  const birthString = `${birthYear}-${birthMonth}-${birthDay}`

  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth() + 1
  const currentDay = today.getDate()
  const thresholdString = `${currentYear - 31}-${currentMonth}-${currentDay}`

  return thresholdString < birthString
}
